import {
    Grid,
    Paper,
    Typography,
    Box,
    CircularProgress,
    Alert,
    Card,
    CardContent,
    Avatar,
    Chip
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRTL } from '../../../hooks/useRTL';
import { COLORS } from '../../../utils/constants';

const TopRepresentatives = ({ analytics, analyticsLoading, error }) => {
    const { t } = useTranslation();
    const { isRTL, containerProps } = useRTL();

    if (analyticsLoading) {
        return (
            <Grid container spacing={3} sx={{ mb: 5, ...containerProps }}>
                <Grid item xs={12}>
                    {error ? (
                        <Alert severity="error">{error}</Alert>
                    ) : (
                        <Box display="flex" justifyContent="center" alignItems="center" minHeight="120px">
                            <CircularProgress />
                        </Box>
                    )}
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid container spacing={3} sx={{ mb: 5, ...containerProps }}>
            <Grid item xs={12}>
                <Paper sx={{ p: 3, ...containerProps }}>
                    <Typography variant="h6" gutterBottom>
                        {t('dashboard.topRepresentatives')}
                    </Typography>
                    <Grid container spacing={2}>
                        {analytics.topRepresentatives?.map((representative, index) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={representative._id}>
                                <Card variant="outlined">
                                    <CardContent>
                                        <Box display="flex" alignItems="center" mb={2}>
                                            <Avatar sx={{
                                                bgcolor: COLORS[index % COLORS.length],
                                                mr: isRTL ? 0 : 2,
                                                ml: isRTL ? 2 : 0
                                            }}>
                                                {representative.name.charAt(0)}
                                            </Avatar>
                                            <Box>
                                                <Typography variant="subtitle1" fontWeight="bold">
                                                    {representative.name}
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary">
                                                    ID: {representative.id}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                            <Box>
                                                <Chip
                                                    size="small"
                                                    label={`${representative.patientsCount} ${t('representatives.patients')}`}
                                                    color="primary"
                                                    variant="outlined"
                                                    sx={{
                                                        mr: isRTL ? 0 : 1,
                                                        ml: isRTL ? 1 : 0,
                                                    }}
                                                />
                                                <Chip
                                                    size="small"
                                                    label={`${representative.doctorsCount} ${t('representatives.doctors')}`}
                                                    color="secondary"
                                                    variant="outlined"
                                                />
                                            </Box>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default TopRepresentatives;